import {json, MiniSignal, texture} from "p3";
import common from "../../common";
import { iswebfont, locale, resizeLabelToFitText } from "../../utils";

export default class LanguagePanel extends PIXI.Container {

    constructor(useIcon) {

        super();

        this._useIcon = useIcon;

        this.signals = {
            languageChange: new MiniSignal()
        };

        this._chosenLanguage = null;

        this.init();
    }

    init() {

        this._languagePanel = new PIXI.NineSlicePlane(texture("panel_popup_9slice"), 80, 110, 80, 80);
        this._languagePanel.width = 900;
        this._languagePanel.height = 700;
        this._languagePanel.interactive = true;
        this.addChild(this._languagePanel);

        const buttonHolder = new PIXI.Container();
        buttonHolder.x = 0;
        buttonHolder.y = 0;
        this._languagePanel.addChild(buttonHolder);

        if (this._useIcon) {
            const icon = new PIXI.Sprite(texture("icon_language_large"));
            icon.anchor.set(0.5);
            icon.position.set(this._languagePanel.width/2, 60);
            this._languagePanel.addChild(icon);
        } else {
            const title = new PIXI.BitmapText(locale('ui_settings_language').toUpperCase(), {
                fontName: "Alghera Pro",
                fontSize: 40,
                align: "center",
                tint: 0x000000
            });
            title.anchor.set(0.5);
            title.position.set(this._languagePanel.width/2, 60);
            this._languagePanel.addChild(title);
            resizeLabelToFitText(title, this._languagePanel.width-60);
        }

        const state = new P3.ButtonStates(PIXI.Texture.EMPTY);
        let currentX = 0;
        let currentY = 0;
        const areaWidth = this._languagePanel.width * 0.9;
        const areaHeight = this._languagePanel.height * 0.7;
        const boxWidth = 200;
        const boxHeight = 50;
        const gridWidth = 3;
        const gridHeight = 7;
        const xMargin = (areaWidth - (boxWidth * gridWidth)) / (gridWidth-1); 
        const yMargin = (areaHeight - (boxHeight * gridHeight)) / (gridHeight-1); 
        
        const languageTitles = json("locale").languages;
        for (let i in languageTitles) {
            let button = new P3.Button(state);
            button.id = i;
            button.position.set(
                ((this._languagePanel.width - areaWidth)/2) + (currentX * (boxWidth)) + (boxWidth/2) + (currentX * xMargin),
                ((this._languagePanel.height - areaHeight)/2) + (currentY * (boxHeight)) + (boxHeight/2) + (currentY * yMargin)
            );
            let buttonBacking = new PIXI.Sprite(PIXI.Texture.WHITE);
            buttonBacking.alpha = 0;
            buttonBacking.anchor.set(0.5, 0.5);
            button.signals.click.add(this._onLanguageChange, this);
            button.addChild(buttonBacking);
            let text = languageTitles[i].en;
            if (i == 'ar') {
                text = text.split("").reverse().join("");
            }
            let buttonText = new PIXI.BitmapText(text, {
                fontName: "alghera_pro_languages",
                fontSize: 45,
                align: "center",
                tint: 0x000000,
                maxWidth: 200
            });
            buttonText.anchor.set(0.5, 0);
            button.addChild(buttonText);
            buttonHolder.addChild(button);
            buttonBacking.width = buttonText.width;
            buttonBacking.height = buttonText.height;

            if (currentX >= gridWidth-1) {
                currentX = 0;
                currentY ++;
            } else {
                currentX ++;
            }
        }
    }

    _onLanguageChange(button) {
        this._chosenLanguage = button.id;
        this.signals.languageChange.dispatch(button);
    }

    showConfirm(scene, tweens, callback) {

        const fill = new PIXI.Sprite(PIXI.Texture.WHITE);
        fill.tint = 0x000000;
        fill.alpha = 0;
        fill.interactive = true;
        fill.width = common.STAGE_WIDTH;
        fill.height = common.STAGE_HEIGHT;
        scene.addChild(fill);

        const panel = new PIXI.NineSlicePlane(texture("panel_popup_9slice"), 80, 110, 80, 80);
        panel.width = 470;
        panel.height = 310;
        panel.x = (common.STAGE_WIDTH/2) - (panel.width/2);
        panel.y = common.STAGE_HEIGHT;
        scene.addChild(panel);

        let confirmText = json("locale")['ui_splash_delete_confirm_title'][this._chosenLanguage];

        let title;
        if(iswebfont(this._chosenLanguage)) {
            title = new PIXI.Text(confirmText, {
                fontFamily: "FredFredBurger",
                fontSize: 30,
                align: "center",
                fill: 0x0,
                wordWrap: true,
                wordWrapWidth: 400
            });
        } else {
            title = new PIXI.BitmapText(confirmText, {
                fontName: "Alghera Pro",
                fontSize: 40,
                align: "center",
                tint: 0x000000
            });
        }
        title.anchor.set(0.5);
        title.position.set(panel.width/2, 60);
        panel.addChild(title);
        resizeLabelToFitText(title, panel.width-60);

        panel.height = Math.max(panel.height, 200 + panel.bottomHeight);

        const hidePanel = (cb) => {
            tweens.push(
                gsap.to(panel, 0.3, {y:common.STAGE_HEIGHT, ease:Expo.easeIn, onComplete:() => {
                    if (cb) {
                        cb();
                    }
                }}),
                gsap.to(fill, 0.2, {alpha:0, ease:Sine.easeIn, onComplete:() => {
                    scene.removeChild(fill);
                }})
            );
        }

        const crossButton = P3.Button.create(
            texture("btn_action_medium_out"),
            null,
            null,
            texture("btn_icon_medium_cross")
        );
        scene.signalListeners.push(
            crossButton.signals.click.add(() => {
                hidePanel();
            }, this)
        );
        crossButton.x = (panel.width/2) - 100;
        crossButton.y = 170;
        panel.addChild(crossButton);

        const tickButton = P3.Button.create(
            texture("btn_action_medium_out"),
            null,
            null,
            texture("btn_icon_medium_tick")
        );
        scene.signalListeners.push(
            tickButton.signals.click.add(() => {
                hidePanel(callback);
            }, this)
        );
        tickButton.x = (panel.width/2) + 100;
        tickButton.y = 170;
        panel.addChild(tickButton);

        tweens.push(
            gsap.to(panel, 0.3, {y:(common.STAGE_HEIGHT / 2) - (panel.height/2), ease:Expo.easeOut}),
            gsap.to(fill, 0.2, {alpha:0.3, ease:Sine.easeIn})
        );
    }

}